import Vue from "vue";
import { removeFromStorage } from "@/utils/storage";
import dayjs from "dayjs";
const API_URL = process.env.VUE_APP_API_URL;
const appPlugin = new Vue({
  data() {
    return {
      listeners: {},
      userInfo: null,
      userRole: null,
      token: null,
      listBill: [],
      multipleSelection: [],
      fillDataNumber: 0,
      billTypes: [],
      billOptions: [],
      zIndexPopup: 100,
      islogin: false,
      summary: {
        totalPending: 0,
        totalApproved: 0,
        totalRejected: 0,
      },
      selectedDateRange: [dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"), dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss")],
      departmentAdmin: null,
      fillBillAddressValue: null,
      formBills: null,
      selectedBillType: null,
      searchCode: null,
      checkStatus: null,
      reviewed: null,
      totalExpense: 0,
      theme: {
        brandColor: '#024bb3',
        logoUrl: ''
      },
    }
  },
  created() {
    this.fetchTheme();
  },
  methods: {
    on(event, callback) {
      if (!this.listeners[event]) this.listeners[event] = [];
      this.listeners[event].push(callback);
    },
    emit(event, payload) {
      if (this.listeners[event]) {
        this.listeners[event].forEach(cb => cb(payload));
      }
    },
    off(event, callback) {
      if (!this.listeners[event]) return;
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    },
    // Chuyển đổi màu hex/rgb thành chuỗi "R G B" cho Tailwind opacity
    _colorToRgbStr(colorStr) {
      if (!colorStr) return '2 75 179';
      if (colorStr.startsWith('rgb')) {
        const match = colorStr.match(/\d+/g);
        if (match && match.length >= 3) return `${match[0]} ${match[1]} ${match[2]}`;
      } else {
        let hex = colorStr.replace(/^#/, '');
        if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
        const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})/i.exec(hex);
        if (result) return `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`;
      }
      return '2 75 179';
    },

    // Apply theme object vào CSS variables & favicon
    _applyThemeCss(theme) {
      const color = theme.brandColor || '#024bb3';
      document.documentElement.style.setProperty('--color-brand', color);
      document.documentElement.style.setProperty('--color-brand-rgb', this._colorToRgbStr(color));

      const faviconUrl = '/logo-favicon-hla.png';
      let favicon = document.getElementById('app-favicon') || document.querySelector("link[rel*='icon']");
      if (favicon) {
        favicon.href = faviconUrl;
      }
    },

    // Chuẩn hóa theme config từ API response
    _normalizeTheme(raw) {
      return {
        brandColor:       raw.brandColor        || '#024bb3',
        logoUrl:          raw.logoUrl           || 'https://s3.ap-southeast-1.amazonaws.com/guta.content/logo_Highland_Agri_op_4_699872b09d.png',
        logoId:           raw.logoId            || null,
        loginLogoUrl:     raw.loginLogoUrl      || '',
        loginLogoId:      raw.loginLogoId       || null,
        appName:          raw.appName           || 'HIGHLAND AGRI',
        headerBillUrl:    raw.headerBillUrl     || '',
        headerBillId:     raw.headerBillId      || null,
        loginPortalLabel: raw.loginPortalLabel  || 'PORTAL MANAGEMENT',
        loginTitle:       raw.loginTitle        || 'Hệ Thống Phiếu Chi Điện Tử',
        loginSubtitle:    raw.loginSubtitle     || 'Giải pháp quản lý tài chính toàn diện. Tối ưu hóa quy trình, kiểm soát chi phí chặt chẽ và an toàn thông tin tuyệt đối.',
        loginCopyright:   raw.loginCopyright    || '© 2024 HIGHLAND AGRI. All rights reserved.',
      };
    },

    async fetchTheme() {
      const CACHE_KEY = 'app_theme';

      // ── Bước 1: Load từ localStorage và apply ngay (không chờ API)
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          const cachedTheme = JSON.parse(cached);
          this.theme = cachedTheme;
          this._applyThemeCss(cachedTheme);
        }
      } catch (e) {
        console.warn('Không đọc được theme cache:', e);
      }

      // ── Bước 2: Fetch API ngầm để sync
      try {
        const res = await fetch(`${API_URL}/theme`);
        if (!res.ok) return;

        const raw = await res.json();
        const freshTheme = this._normalizeTheme(raw);

        // So sánh để chỉ update khi thực sự có thay đổi
        const isSame = JSON.stringify(freshTheme) === JSON.stringify(this.theme);
        if (!isSame) {
          this.theme = freshTheme;
          this._applyThemeCss(freshTheme);
          localStorage.setItem(CACHE_KEY, JSON.stringify(freshTheme));
        }
      } catch (err) {
        console.error('Không thể sync theme từ API:', err);
      }
    },
    async getUserByEmail(token) {
      await this.$axios
        .get(`${API_URL}/authuserslog`, {
          headers: {
            "Content-Type": "application/json",
            "X-Authorization": `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            this.userInfo = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.status === 401) {
            console.log('không có quyền');
            removeFromStorage("uToken");
            this.islogin = false
            return
          }
          this.$notify.error({
            title: "Thất bại",
            message: "Xảy ra lỗi khi lấy thông tin người dùng.",
          });
        });
    },

  },
  computed: {
    isMobile() {
      const userAgent = navigator.userAgent;
      const classicMobileCheck = /Mobi|Android|iPhone|iPod/i.test(userAgent);
      if (classicMobileCheck) {
          return true;
      }
      if (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1) {
          return true;
      }

      return false;
    }
  },
});
export default {
  install(Vue, options) {
    Vue.prototype.$app = appPlugin;
  },
};
